import { useAuth } from '../contexts/AuthContext';

export const useCustomKeycloak = () => {
  const { keycloak, initialized } = useAuth();
  return { keycloak, initialized };
};
